import Blog from '../components/Blog';

const BlogContainer = Blog;

export default BlogContainer;
